import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { CommonWrapper, SectionTitle } from 'screens/AgentOfficePages/styled';


export const Wrapper = styled(CommonWrapper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const NavWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PageNavSection = styled.div`
  .pagination {
    margin: 0;
  }
`;

export const List = styled.div`
  display: grid;
  gap: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(1)}`};
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export const TabsSection = styled.div`
  display: flex;
  align-items: center;
`;

export const TabWrapper = styled.div<{ isActive?: boolean }>`
  padding: ${({ theme }) => `${theme.spacing(2)} 0 ${theme.spacing(1)} ${theme.spacing(3)}`};
  border-bottom: 1px solid ${({ theme, isActive }) => isActive ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey8};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  cursor: pointer;
`;

export const Title = styled(Text)<{ isActive: boolean }>`
  color: ${({ theme, isActive }) => isActive ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey3};
`;

export const AreaTitle = styled(SectionTitle)`
  margin-left: auto;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(2)};
  `}
  span {
    font-weight: 400;
  }
`;
